export default "__VITE_ASSET__Bn3n9Mjv__"